/**
 * Reels shown on the home page and /reels.
 * Videos live in /public/assets/reels and are loaded with preload="none",
 * so nothing downloads until the visitor actually taps play.
 */

export const reels = [
  {
    id: 'grand-opening',
    title: 'Grand Opening',
    caption: 'The doors open on Science City Road.',
    src: '/assets/reels/reel-grand-opening.mp4',
    poster: '/assets/gallery/post-09-7.jpg',
  },
  {
    id: 'maharani',
    title: 'Maharani Heritage',
    caption: 'Launching the Maharani Heritage collection.',
    src: '/assets/reels/reel-maharani.mp4',
    poster: '/assets/gallery/post-01-thumbnail-2.jpg',
  },
  {
    id: 'bridal-heritage',
    title: 'Bridal Heritage',
    caption: 'Layering a full bridal look, piece by piece.',
    src: '/assets/reels/reel-bridal-heritage.mp4',
    poster: '/assets/gallery/post-03-thumbnail.jpg',
  },
  {
    id: 'antique-showcase',
    title: 'Antique Showcase',
    caption: 'Matte nakashi gold under studio light.',
    src: '/assets/reels/reel-antique-showcase.mp4',
    poster: '/assets/gallery/post-06-thumbnail.jpg',
  },
  {
    id: 'royal-tradition',
    title: 'Royal Tradition',
    caption: 'Heritage silhouettes from the workshop.',
    src: '/assets/reels/reel-royal-tradition.mp4',
    poster: '/assets/gallery/post-01-thumbnail.jpg',
  },
  {
    id: 'opening-soon',
    title: 'Opening Soon',
    caption: 'The teaser that started it.',
    src: '/assets/reels/reel-opening-soon.mp4',
    poster: '/assets/gallery/post-03-thumbnail-3.jpg',
  },
];
